<template>
  <body class="ourMission-body">
    <div class="h1-wrapper">
      <div class="h1">
        Our mission at Wecobi is clear and ambitious: to transform unsold
        inventory from a liability into an opportunity for growth and
        sustainability.
      </div>
    </div>
    <div class="text-wrapper">
      <div class="text">
        By the year 2030, we are committed to rescuing 100 million items from
        ending up in landfills. This effort is not just about numbers—it’s about
        real, tangible environmental benefits. By achieving this goal, we will
        prevent the emission of approximately 700,000 metric tons of CO2 and
        save an estimated 270 million liters of water. These are resources that
        would otherwise be lost through wasteful disposal practices. Our
        approach promotes a circular economy, ensuring that products are not
        only used but also revalued, extending their lifecycle and reducing
        their environmental footprint.
      </div>
    </div>
  </body>
</template>

<script>
export default {
  name: "OurMission",
};
</script>

<style scoped>
.ourMission-body {
  width: 100%;
  background: #f7f7fa;
  border-radius: 20px;
  padding: 48px 0px 90px 0px;
  display: flex;
  justify-content: space-evenly;
}
.h1-wrapper,
.text-wrapper {
  display: flex;
}
.h1-wrapper {
  justify-content: center;
}
.h1 {
  max-width: 703px;
  font-size: 25px;
  font-weight: 400;
}
.text {
  max-width: 630px;
  font-size: 14px;
  font-weight: 400;
  color: #434343;
}

@media (max-width: 1024px) {
  .h1 {
    max-width: 378px;
    font-size: 20px;
  }
  .text {
    max-width: 378px;
    font-size: 12px;
  }
}

@media (max-width: 744px) {
  .ourMission-body {
    padding: 40px 0px 70px 0px;
  }
  .h1,
  .text {
    max-width: 285px;
  }
  .h1 {
    font-size: 18px;
  }
}

@media (max-width: 588px) {
  .h1,
  .text {
    max-width: 207px;
  }
}
@media (max-width: 431px) {
  .ourMission-body {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  .h1,
  .text {
    max-width: 358px;
  }
  .text-wrapper {
    justify-content: center;
  }
}
</style>
